import { PlatformLocationFeatureV1 } from '@frontend/api-platform-location-feature';
import { i18next } from '@frontend/i18n';

export type TrueLarkPromoSource = 'dashboard' | 'phone-analytics';

export const TrueLarkDemoLinkBySourceMap: Record<TrueLarkPromoSource, string> = {
  dashboard:
    'https://www.getweave.com/truelark/?showForm=true&utm_source=product&utm_medium=banner&utm_campaign=in_app_truelark_dashboard',
  'phone-analytics':
    'https://www.getweave.com/truelark/?showForm=true&utm_source=product&utm_medium=banner&utm_campaign=in_app_truelark_analytics',
};

export const PromoSourceNotificationSourceMap: Record<TrueLarkPromoSource, PlatformLocationFeatureV1.Types.Source> = {
  dashboard: PlatformLocationFeatureV1.Types.Source.SOURCE_DASHBOARD_TEASER_BANNER,
  'phone-analytics': PlatformLocationFeatureV1.Types.Source.SOURCE_PHONE_ANALYTICS_TEASER,
};

export const TrueLarkBannerDismissActions = [
  {
    label: i18next.t('Remind me in 3 days', { ns: 'highValueAdoption>>true-lark' }),
    trackingId: 'remind-in-3-days-action-click',
    action: PlatformLocationFeatureV1.Types.Action.ACTION_REMIND_AFTER_3_DAYS,
  },
  {
    label: i18next.t('Never show again', { ns: 'highValueAdoption>>true-lark' }),
    trackingId: 'never-show-again-action-click',
    action: PlatformLocationFeatureV1.Types.Action.ACTION_NEVER_SHOW_AGAIN,
  },
];

export const TRUE_LARK_MISSED_CALL_PROMO_FF = 'true-lark:missed-call-promo-banner';

export const TRUE_LARK_MESSAGING_CF = ['truelarkaimessaging', 'aimessaging'];
export const TRUE_LARK_VOICE_CF = 'truelarkaivoice';
export const ONBOARDED_DURATION_DAYS = 60;
export const TRUE_LARK_ELIGIBLE_PMS_REGEX = /(opendental|dentrix|eaglesoft)/i;
